import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { LegalLayout } from "@/components/LegalLayout";
import { NAV } from "@/data/site";

const LEGAL = [
  { label: "Privacy Policy", to: "/privacy-policy" },
  { label: "Website Terms & Conditions", to: "/website-terms" },
  { label: "Cookie Policy", to: "/cookie-policy" },
  { label: "Accessibility", to: "/accessibility" },
];

const Group = ({ title, links }) => (
  <div>
    <p className="font-display text-xs uppercase tracking-[0.25em] text-slate-400">{title}</p>
    <ul className="mt-5 divide-y divide-slate-200 border-t border-slate-200">
      {links.map((l) => (
        <li key={l.to}>
          <Link
            to={l.to}
            data-testid={`sitemap-${l.label.toLowerCase().replace(/[^a-z]+/g, "-").replace(/(^-|-$)/g, "")}`}
            className="group flex items-center justify-between py-4 font-display text-lg uppercase tracking-tight text-[#0A1128] transition-colors hover:text-[#1D4ED8]"
          >
            {l.label}
            <ArrowUpRight size={18} className="opacity-40 transition-opacity group-hover:opacity-100" />
          </Link>
        </li>
      ))}
    </ul>
  </div>
);

export default function Sitemap() {
  return (
    <LegalLayout title="Sitemap">
      <div className="grid gap-14 md:grid-cols-2">
        <Group title="Main pages" links={NAV} />
        <Group title="Legal" links={LEGAL} />
      </div>
    </LegalLayout>
  );
}
